var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg24Other = function Svg24Other(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM8.25 13.5H5.25V10.5H8.25V13.5ZM12 13.75C11.03 13.75 10.25 12.97 10.25 12C10.25 11.04 11.03 10.25 12 10.25C12.97 10.25 13.75 11.04 13.75 12C13.75 12.97 12.97 13.75 12 13.75ZM15.08 13.52L16.83 10.49L18.58 13.52H15.08Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg24Other, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEyIDNDNy4wMyAzIDMgNy4wMyAzIDEyQzMgMTYuOTcgNy4wMyAyMSAxMiAyMUMxNi45NyAyMSAyMSAxNi45NyAyMSAxMkMyMSA3LjAzIDE2Ljk3IDMgMTIgM1pNOC4yNSAxMy41SDUuMjVWMTAuNUg4LjI1VjEzLjVaTTEyIDEzLjc1QzExLjAzIDEzLjc1IDEwLjI1IDEyLjk3IDEwLjI1IDEyQzEwLjI1IDExLjA0IDExLjAzIDEwLjI1IDEyIDEwLjI1QzEyLjk3IDEwLjI1IDEzLjc1IDExLjA0IDEzLjc1IDEyQzEzLjc1IDEyLjk3IDEyLjk3IDEzLjc1IDEyIDEzLjc1Wk0xNS4wOCAxMy41MkwxNi44MyAxMC40OUwxOC41OCAxMy41MkgxNS4wOFoiIC8+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };